export const SP_THEME_KEY = 'spTheme'
export const SP_THEME_MERCHANT_KEY = 'spThemeMerchantId'
/** theme.json for this tab only. Survives refresh; dies when the tab closes. */
export const SP_THEME_JSON_SESSION_KEY = 'spThemeJson'

const THEME_ON = new Set(['on', '1', 'true'])

export function parseThemeParam(raw: string | null | undefined): boolean {
  if (!raw) return false
  return THEME_ON.has(raw.trim().toLowerCase())
}

export function persistThemeFromSearch(search: URLSearchParams): void {
  const raw = search.get('theme')
  if (raw == null) return
  if (raw.trim().toLowerCase() === 'off' || !parseThemeParam(raw)) {
    localStorage.removeItem(SP_THEME_KEY)
    return
  }
  localStorage.setItem(SP_THEME_KEY, 'on')
}

export function persistPathMerchantId(pathMerchantId: string | undefined): void {
  if (!pathMerchantId) return
  localStorage.setItem(SP_THEME_MERCHANT_KEY, pathMerchantId)
}

export function persistMerchantIdFromPath(pathname: string): void {
  const match = pathname.match(/^\/merchant\/([^/]+)/)
  if (match?.[1]) persistPathMerchantId(match[1])
}

export function isThemeOn(search: URLSearchParams): boolean {
  const raw = search.get('theme')
  if (raw != null) {
    if (raw.trim().toLowerCase() === 'off') return false
    return parseThemeParam(raw)
  }
  return localStorage.getItem(SP_THEME_KEY) === 'on'
}

export function getStoredMerchantId(): string {
  return localStorage.getItem(SP_THEME_MERCHANT_KEY) || ''
}

export function persistScanTheme(search: URLSearchParams, pathMerchantId?: string): void {
  const raw = search.get('theme')
  if (raw == null || raw.trim().toLowerCase() === 'off' || !parseThemeParam(raw)) {
    localStorage.removeItem(SP_THEME_KEY)
  } else {
    localStorage.setItem(SP_THEME_KEY, 'on')
  }
  if (pathMerchantId) {
    persistPathMerchantId(pathMerchantId)
  } else {
    localStorage.removeItem(SP_THEME_MERCHANT_KEY)
  }
}

export function billPathWithTheme(search: URLSearchParams): string {
  return isThemeOn(search) ? '/bill?theme=on' : '/bill'
}
